const nameSort = (g1, g2) => {
  const g1l = g1.toLowerCase()
  const g2l = g2.toLowerCase()
  return g1l < g2l ? -1 : g1l > g2l ? 1 : 0
}

export default nameSort



// WEBPACK FOOTER //
// ./src/utils/nameSort.js